export default __webpack_public_path__ + "static/media/work5.02536a67.png";